<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>Email</label>
    <multi-select v-model='selectedEmails' :getter='getContacts' :template="contactEmailTemplate" />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      selectedEmails: [],
    }
  },
  computed: {
    selectedEmailsIds() {
      return this.selectedEmails.map(c => c.email)
    },
    predicateQuery() {
      return this.predicate ? 'filters[email_in]' : 'filters[email_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[email_in]']
      delete newQuery['filters[email_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedEmailsIds })

      this.$router.push({ query: newQuery })
    },
    contactEmailTemplate(c) {
      return c.email
    },
    getContacts(params) {
      let q = params.q
      let page = params.page
      return this.listStore.getContacts({ 'filters[email_blank]': false, 'filters[email_cont]': q, page: page })
    },
  }
}
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
